import {isOnlineDomain} from 'common/HelperFunctions'

/**
 * Which dashboard students and parents land on at /dashboard, by domain.
 *
 * - `native`: the mobile-parity dashboard (stats, attention required,
 *   timeline, panels, e-card) — `Dashboard.tsx`. Still being improved, so it
 *   shows on the DEV server only (`*.ilmversity.online`).
 * - `legacy`: the original Metronic dashboard (greeting, top links, news and
 *   the annual calendar), as it was before the native family portal
 *   (PR #2451) — `legacy/Dashboard.tsx`. Every live server (production,
 *   Lyceum, AI, LGS and any custom domain) shows this one.
 *
 * Both stay in the codebase. To release the native dashboard everywhere,
 * return `'native'` here; nothing else changes. Parents who are sent to the
 * PHP portal are not affected either way.
 */
export type FamilyDashboardVersion = 'legacy' | 'native'

export const familyDashboardVersion = (): FamilyDashboardVersion =>
  isOnlineDomain() ? 'native' : 'legacy'
